export default "__VITE_ASSET__z8PZ6_7c__"